import { Typography } from "antd";
import ReceiveSummeryReport from "../components/report/ReceiveSummeryReport";
import SellSummeryReport from "../components/report/SellSummeryReport";
import useTranslation from "../hooks/TranslationContext";
import SpecificDateCreatedReceiptsCountReport from "../components/report/SpecificDateCreatedReceiptsCountReport";
import SpecificDateDeliveredReceiptsCountReport from "../components/report/SpecificDateDeliveredReceiptsCountReport";
import SpecificDateReceivesAmountReport from "../components/report/SpecificDateReceivesAmountReport";
import SpecificDateSellsAmountReport from "../components/report/SpecificDateSellsAmountReport";
import SpecificDateCreatedServicesCountReport from "../components/report/SpecificDateCreatedServicesCountReport";
import SpecificDateReadyServicesCountReport from "../components/report/SpecificDateReadyServicesCountReport";
import SpecificDateDeliveredServicesCountReport from "../components/report/SpecificDateDeliveredServicesCountReport";
import SellServiceItemSummeryReport from "../components/report/SellServiceItemSummeryReport";
import SellServiceSummeryReport from "../components/report/SellServiceSummeryReport";

export default function ReportPage() {
  const { t } = useTranslation();

  return (
    <>
      <div className="flex justify-between items-center mb-4">
        <Typography.Title level={4}>{t("reports")}</Typography.Title>
      </div>
      <div className="dashboard-container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Progress Card */}
        {/* <div className="p-5 bg-white shadow rounded min-h-32">
          <SmsPanelRemainingBalance />
        </div> */}

        {/* <div className="p-5 bg-white shadow rounded">
              </div>

              <div className="p-5 bg-white shadow rounded">

              </div> */}
      </div>
      <div className="dashboard-container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Progress Card */}
        <div className="p-5 bg-white shadow rounded min-h-32">
          <SpecificDateCreatedReceiptsCountReport/>
        </div>
        <div className="p-5 bg-white shadow rounded min-h-32">
          <SpecificDateDeliveredReceiptsCountReport/>
        </div>
        <div className="p-5 bg-white shadow rounded min-h-32">
          <SpecificDateReceivesAmountReport/>
        </div>
        <div className="p-5 bg-white shadow rounded min-h-32">
          <SpecificDateSellsAmountReport/>
        </div>
        <div className="p-5 bg-white shadow rounded min-h-32">
          <SpecificDateCreatedServicesCountReport/>
        </div>
        <div className="p-5 bg-white shadow rounded min-h-32">
          <SpecificDateReadyServicesCountReport/>
        </div>
        <div className="p-5 bg-white shadow rounded min-h-32">
          <SpecificDateDeliveredServicesCountReport/>
        </div>
      </div>
      <div className="dashboard-container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 pt-6">
        <div className="p-0 pt-5 md:p-5 bg-white shadow rounded col-span-1 md:col-span-3">
          <SellSummeryReport />
        </div>
        <div className="p-0 pt-5 md:p-5 bg-white shadow rounded col-span-1 md:col-span-3">
          <ReceiveSummeryReport />
        </div>
      </div>
      <div className="dashboard-container grid grid-cols-1 md:grid-cols-2 gap-6 pt-6">
        <div className="p-0 pt-5 md:p-5 bg-white shadow rounded col-span-1">
          <SellServiceSummeryReport />
        </div>
        <div className="p-0 pt-5 md:p-5 bg-white shadow rounded col-span-1">
          <SellServiceItemSummeryReport />
        </div>
      </div>
    </>
  );
}
